import * as React from 'react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import { LoadingSpinner } from '.';

// Styles
const s = require('./SavingIndicator.css');

// Enumerables
export enum SavingIndicatorStatus {
    None,
    Saving,
    Success,
    Error,
}

// Props
interface ISavingIndicatorProps {
    className?: string | null;
    status: SavingIndicatorStatus
    dismissIn?: number
    align?: 'left' | 'center' | 'right' | null;
    labels?: {
        note?: string;
        saving?: string
        success?: string
        error?: string
        retry?: string
    }
    onRetry?: () => void
}

@observer
export class SavingIndicator extends React.Component<ISavingIndicatorProps, any> {
    static get defaultProps(): ISavingIndicatorProps {
        return {
            className: null,
            status: SavingIndicatorStatus.None,
            dismissIn: 5000,
            align: 'right',
            labels: {
                note: '',
                saving: 'Saving...',
                success: 'Saved',
                error: 'Error',
                retry: 'Retry',
            },
            onRetry: null,
        };
    }

    constructor(props: ISavingIndicatorProps) {
        super(props);
    }

    @observable private beginHiding: boolean = false;

    @computed private get show(): boolean {
        if (this.props.status === SavingIndicatorStatus.Success) {
            return this.beginHiding === false;
        } else {
            return this.props.status !== SavingIndicatorStatus.None ||
                (
                    this.props.status === SavingIndicatorStatus.None &&
                    typeof this.props.labels.note !== 'undefined' &&
                    this.props.labels.note.length > 0
                );
        }
    }

    @computed private get label(): { text: string; className: string[]; } {
        let label: string = '';
        const className: string[] = [s.label];
        switch (this.props.status) {
            case SavingIndicatorStatus.Saving:
                label = this.props.labels.saving;
                break;

            case SavingIndicatorStatus.Success:
                label = this.props.labels.success;
                className.push(s.successMsg);
                break;

            case SavingIndicatorStatus.Error:
                label = this.props.labels.error;
                className.push(s.errorMsg);
                break;

            case SavingIndicatorStatus.None:
                label = this.props.labels.note;
                break;

            default:
                break;
        }

        return {
            text: label,
            className,
        };
    }

    @computed private get alignmentClassName(): string {
        const { align } = this.props;

        return align === 'right'
            ? s.alignRight
            : align === 'left'
                ? s.alignLeft
                : align === 'center'
                    ? s.alignCenter
                    : null;
    }

    public componentWillUpdate(nextProps: ISavingIndicatorProps) {
        const { status, dismissIn } = nextProps;
        if (status === SavingIndicatorStatus.Success) {
            setTimeout(() => {
                this.beginHiding = true;
            }, nextProps.dismissIn);
        }
    }

    public render() {
        const { onRetry, align } = this.props;

        return (
            <CSSTransitionGroup
                component="div"
                className={classNames(s.container, this.alignmentClassName, this.props.className)}
                transitionName="fade"
                transitionAppear={true}
                transitionAppearTimeout={300}
                transitionEnter={true}
                transitionEnterTimeout={300}
                transitionLeave={true}
                transitionLeaveTimeout={1000}
            >
                {(this.show) && (
                    <div key="indicator" className={s.indicator}>
                        <LoadingSpinner size={18} active={this.props.status === SavingIndicatorStatus.Saving} />
                        <p key="label" className={classNames(this.label.className)}>
                            {(this.label.text.length > 0) && (
                                <span>{this.label.text}</span>
                            )}
                            {(this.props.status === SavingIndicatorStatus.Error && this.props.onRetry !== null) && (
                                <button onClick={onRetry}>{this.props.labels.retry}</button>
                            )}
                        </p>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/indicator/SavingIndicator.tsx